import { useEffect } from 'react';
import { RelayType } from '@diritto/common/content/constants';
import { ContestId } from '@diritto/common/content/contest.constants';
import { ContentRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLiteRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { SearchContentItem } from 'app-components/search/SearchContentItem';
import { extractContentContestIds, useActiveContentContestIdsDispatch } from 'contexts/ActiveContentContestIdsProvider';
import { EmptyList } from 'ui-components/common/EmptyList';

interface SearchContentListProps {
  contentIds: number[];
  contents: Record<string, ContentRelayDto>;
  profileLites: Record<string, ProfileLiteRelayDto>;
  searchKeyword: string;
  numOfTotalSearchResults: number;
  emptyText?: string;
}

export const SearchContentList = ({
  contentIds,
  contents,
  profileLites,
  searchKeyword,
  numOfTotalSearchResults,
  emptyText = '아직 작품이 없어요.',
}: SearchContentListProps) => {
  const { checkActiveContentContests } = useActiveContentContestIdsDispatch();

  useEffect(() => {
    if (contents && contentIds.length > 0) {
      const contentContestIds = extractContentContestIds(contentIds, contents);
      checkActiveContentContests(ContestId.Contest2026, contentContestIds);
    }
  }, [contents, contentIds, checkActiveContentContests]);

  if (contentIds.length === 0) {
    return <EmptyList description={emptyText} />;
  }

  return (
    <>
      {contentIds.map((id, idx) => {
        const content = contents[id];

        if (content.relayType !== RelayType.Public) {
          return null;
        }
        const author = content.profileId ? profileLites[content.profileId] : undefined;
        if (author && author.isDeleted) {
          return null;
        }

        return (
          <SearchContentItem
            key={id}
            searchKeyword={searchKeyword}
            listItemIndex={idx}
            numOfTotalSearchResults={numOfTotalSearchResults}
            content={content}
            profile={author}
          />
        );
      })}
    </>
  );
};
